import React from 'react';

import { formatCardNumber } from '@eika-infrastruktur/format';
import { CheckmarkAnimation } from '@eika/checkmark-animation';

import useText from '@/hooks/use-text';

interface PushProvisionSuccessProps {
    cardNumber: string;
}

const PushProvisionSuccess = ({ cardNumber }: PushProvisionSuccessProps) => {
    const {
        googleWalletPushProvisionSuccess,
        googleWalletPushProvisionSuccessDescription,
        googleWalletRedirectToGoogleWalletInfoPage,
    } = useText();

    return (
        <div className="google-pay__signing__permission-is-given">
            <CheckmarkAnimation />
            <h3 className="h3">{googleWalletPushProvisionSuccess}</h3>
            <p>{googleWalletPushProvisionSuccessDescription.replace('{}', formatCardNumber(cardNumber))}</p>
            <p>{googleWalletRedirectToGoogleWalletInfoPage}</p>
        </div>
    );
};

export default PushProvisionSuccess;
